<template>
  <div class="tarrif-code">
    <!-- TITULO DE CÓDIGO DE TARIFA -->
    <PmwHeading
      size="paragraph-80"
      weight="weight-light"
      class="tarrif-code--title"
    >
      Código da tarifa

      <PmwParagraph class="tarrif-code--subtitle" size="paragraph-40">
        Limite o acesso à essa tarifa somente através de um código de tarifa.
      </PmwParagraph>
    </PmwHeading>

    <b-row class="tarrif-code--row__rates">
      <!-- CÓDIGO DE TARIFA PROMOCIONAL -->
      <PmwInputRadio
        v-model="typeRate"
        :checked="typeRate === 1"
        :inputValue="1"
        :class="{
          'tarrif-code--radio-button__blocked': corporateRate?.length
        }"
        class="tarrif-code--radio-button"
        label="Código de tarifa promocional"
        name="ratesType"
      />

      <!-- CÓDIGO DE TARIFA CORPORATIVA -->
      <b-row class="tarrif-code--row__rate-with-tooltip">
        <PmwInputRadio
          v-model="typeRate"
          :checked="typeRate === 2"
          :inputValue="2"
          :class="{ 'tarrif-code--radio-button__blocked': promocodes?.length }"
          class="tarrif-code--radio-button"
          label="Código de corporativa"
          name="ratesType"
        />

        <PmwInfoTooltip width="278px">
          <template #content>
            <span
              >Código exclusivo para uma empresa com tarifa corporativa. Pode
              ser o mesmo código de integração ou um diferente.</span
            >
          </template>
        </PmwInfoTooltip>
      </b-row>
    </b-row>

    <!-- FORMULÁRIO DE TARIFA PROMOCIONAL -->
    <div v-if="typeRate === 1">
      <b-row class="tarrif-code--row__input">
        <PmwFormInput
          v-model="codeRate"
          :maxlength="30"
          :showCounter="true"
          label="Código da tarifa"
          placeholder="Escreva aqui"
          size="large"
          class="tarrif-code--input"
        />

        <!-- BOTÃO DE ADICIONAR DATA -->
        <PmwButton
          :hasIcon="true"
          :disabled="!codeRate"
          variation="blue-100"
          class="tarrif-code--button"
          size="fluid"
          @click="addRate('promocodes')"
        >
          Adicionar
        </PmwButton>
      </b-row>

      <!-- CHIP COM AS TARIFAS ADICIONADAS -->
      <b-row v-if="promocodes?.length >= 1" class="tarrif-code--row__chips">
        <Chip
          v-for="(rate, i) in promocodes"
          :key="`period-chip-${i}`"
          class="tarrif-code--chip"
          cols="2"
          close
          @close="removeRate(i, 'promocodes')"
        >
          {{ rate }}
        </Chip>
      </b-row>
    </div>

    <!-- FORMULÁRIO DE TARIFA CORPORATIVA -->
    <div v-else>
      <b-row class="tarrif-code--row__input">
        <PmwFormInput
          v-model="codeRate"
          :maxlength="30"
          :showCounter="true"
          label="Digite o código da tarifa"
          placeholder="Ex: CORP10"
          size="large"
          class="tarrif-code--input"
        />

        <PmwFormInput
          v-model="integrationCode"
          :maxlength="30"
          :showCounter="true"
          label="Digite o código de integração"
          placeholder="Ex: CORP10"
          size="large"
          class="tarrif-code--input"
        />

        <!-- BOTÃO DE TARIFA CORPORATIVA -->
        <PmwButton
          :hasIcon="true"
          :disabled="!codeRate"
          variation="blue-100"
          class="tarrif-code--button"
          size="fluid"
          @click="addRate('corporateRate')"
        >
          Adicionar código
        </PmwButton>
      </b-row>

      <!-- CHIP COM AS TARIFAS ADICIONADAS -->
      <b-row v-if="corporateRate?.length >= 1" class="tarrif-code--row__chips">
        <Chip
          v-for="(rate, i) in corporateRate"
          :key="`period-chip-${i}`"
          class="tariff-code--chip"
          cols="2"
          close
          @close="removeRate(i, 'corporateRate')"
        >
          <span>
            Cód corp: <strong>{{ rate.codigoTarifa }}</strong>
            <span v-if="rate.codigoIntegracao">
              - Cód Integração:
              <strong>{{ rate.codigoIntegracao }}</strong></span
            >
          </span>
        </Chip>
      </b-row>
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwInputRadio from '@solucoes/components-lib-tmp/src/components/elements/PmwInputRadio'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import Chip from '@/components/_base/patterns/Chip'

export default {
  name: 'RateCodesForm',

  components: {
    PmwHeading,
    PmwParagraph,
    PmwInputRadio,
    PmwInfoTooltip,
    PmwFormInput,
    PmwButton,
    Chip
  },

  emits: ['update:promocodes', 'update:corporateRate'],

  props: {
    /** Tarifas promocionais */
    promocodes: {
      type: Array,
      default: () => []
    },

    /** Tarifas corporativas */
    corporateRate: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /**
       * Tipo de tarifa
       * 1 = Promocode
       * 2 = Tarifa Corporativa
       */
      typeRate: 1,

      codeRate: null,

      integrationCode: null
    }
  },

  created() {
    if (this.promocodes?.length >= 1) this.typeRate = 1

    if (this.corporateRate?.length >= 1) this.typeRate = 2
  },

  methods: {
    /**
     * Adiciona chip com a data
     * @param {String} listName: Listagem de qual deve adicionar o item (promocode ou corporativa)
     */
    addRate(listName) {
      /** Verificar se é um novo promocode ou tarifa corporativa */
      const newCode =
        listName === 'corporateRate'
          ? {
              codigoTarifa: this.codeRate,
              codigoIntegracao: this.integrationCode ?? ''
            }
          : this.codeRate

      const updatedList = this[listName]?.length
        ? [...this[listName], newCode]
        : [newCode]

      /** Emitir evento para atualizar o array */
      this.$emit(`update:${listName}`, updatedList)

      this.resetForm()
    },

    /** Resetar formulário */
    resetForm() {
      this.codeRate = ''
      this.integrationCode = ''
    },

    /**
     * Remove um código específico
     * @param {Integer} index: Posição da tarifa promocode para remover
     * @param {String} listName: Listagem de qual deve remover o item (promocode ou corporativa)
     */
    removeRate(index, listName) {
      const updatedList = [...this[listName]]

      updatedList.splice(index, 1)

      this.$emit(`update:${listName}`, updatedList)
    }
  }
}
</script>

<style lang="scss" scoped>
.tarrif-code {
  &--title {
    margin-bottom: 24px;
    min-width: auto;
  }

  &--subtitle {
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
    color: pmw-colors(grey-80);
    line-height: 21px;
    margin-top: 8px;
  }

  &--radio-button {
    ::v-deep {
      input:checked ~ {
        .pmw-input-radio--fake-radio {
          border-color: $pmw-blue;

          &:before {
            background-color: $pmw-blue;
          }
        }
      }
    }

    &__blocked {
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
    }
  }

  &--input {
    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-form-field--label {
        font-weight: font-weight('weight-medium');
      }
      .form-field--label-wrapper {
        line-height: 21px;
        margin-bottom: 3px;
      }
      .pmw-input {
        background: $white;
      }
      .pmw-input--clear {
        z-index: 0;
      }
      .pmw-input__focus {
        border-color: $pmw-blue;
      }

      .pmw-input--field {
        background: $pmw-white;

        &:focus {
          border-color: $pmw-blue;
        }
      }

      .pmw-input__disabled {
        input {
          background: pmw-colors('grey-20');
          color: $pmw-gray-darker;
        }
      }

      .pmw-custom-tooltip {
        line-height: 18px;
      }
    }
  }

  &--button {
    max-width: 188px;
  }

  &--chip {
    border-radius: 5px;
    border: none;
    color: $pmw-gray-dark;
    background: pmw-colors('grey-10');

    b {
      font-weight: font-weight('weight-bold');
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 28px;
    margin-bottom: 24px;

    &__chips {
      max-width: 900px;
      gap: 13px;
    }

    &__rates {
      gap: 56px;
      margin-bottom: 46px;
    }

    &__input {
      gap: 26px;
      margin-bottom: 42px;
      align-items: end;
    }

    &__rate-with-tooltip {
      margin-bottom: 0;
      gap: 13px;
    }
  }
}
</style>
